import React from "react";
import ImageZoom from "react-image-zooom";

const Certificate = ({ img, productName, price, color }) => {
  
  // Ensure URL is always valid to prevent broken links
  const validUrl = price?.startsWith("http://") || price?.startsWith("https://")
    ? price
    : `https://${price}`;

  return (
    <article className="w-full relative group border-[1px] rounded-md shadow-sm">
      {/* SEO-friendly image container */}
      <div className="max-w-80 max-h-25 relative overflow-y-hidden">
        <ImageZoom 
          src={img} 
          alt={`${productName} Official Certificate – Verified Document`} 
          zoom="300" 
        />
      </div>

      {/* SEO Improved Content */}
      <div className="max-w-80 py-6 flex flex-col gap-2 px-4 border-t">
        <div className="flex items-center justify-between font-titleFont">
          
          {/* Product / Certificate Title */}
          <h2 className="text-lg text-primeColor font-bold leading-snug">
            {productName}
          </h2>

          {/* Verified Link */}
          <a 
            className="text-[#555] text-sm hover:underline hover:text-primeColor duration-200"
            href={validUrl}
            target="_blank"
            rel="noopener noreferrer"
            title={`${productName} Certificate Verification Link`}
          >
            View Certificate
          </a>
        </div>

        {/* Certificate Number */}
        <p className="text-[#666] text-sm">
          Certificate Number: <span className="font-semibold">{color}</span>
        </p>
      </div>
    </article>
  );
};

export default Certificate;
